var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c;
import { createMuiTheme } from '@material-ui/core/styles';
import { green, grey, red } from '@material-ui/core/colors';
var fontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
var rawTheme = createMuiTheme({
    palette: {
        primary: {
            light: '#69696a',
            main: '#e62958',
            dark: '#1e1e1f'
        },
        secondary: {
            light: '#e62958',
            main: '#000',
            dark: '#e62958'
        },
        warning: {
            main: '#ffc071',
            dark: '#ffb25e'
        },
        error: {
            main: red[500],
            dark: red[700]
        },
        success: {
            main: green[500],
            dark: green[700]
        }
    },
    typography: {
        fontFamily: fontFamily
    },
    overrides: {
        MuiButton: {
            text: {
                borderRadius: 3,
                border: 0,
                color: 'white',
                height: 48,
                padding: '0 30px',
                boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)'
            }
        },
        MuiLink: {
            root: {
                cursor: 'pointer'
            }
        }
    }
});
var theme = __assign(__assign({}, rawTheme), { palette: __assign(__assign({}, rawTheme.palette), { background: __assign(__assign({}, rawTheme.palette.background), { default: rawTheme.palette.common.white, placeholder: grey[200] }) }), typography: __assign(__assign({}, rawTheme.typography), { h1: {
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif"',
            fontWeight: 300,
            fontSize: '6rem',
            lineHeight: 1.167,
            letterSpacing: '-0.01562em'
        }, h2: {
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif"',
            fontWeight: 300,
            fontSize: '3.75rem',
            lineHeight: 1.2,
            letterSpacing: '-0.00833em'
        }, h3: {
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif"',
            fontWeight: 400,
            fontSize: '3rem',
            lineHeight: 1.167,
            letterSpacing: '0em'
        }, h4: {
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif"',
            fontWeight: 400,
            fontSize: '2.125rem',
            lineHeight: 1.235,
            letterSpacing: '0.00735em'
        }, h5: {
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif"',
            fontWeight: 400,
            fontSize: '1.5rem',
            lineHeight: 1.334,
            letterSpacing: '0em'
        }, h6: {
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif"',
            fontWeight: 500,
            fontSize: '1.25rem',
            lineHeight: 1.6,
            letterSpacing: '0.0075em'
        }, subtitle1: __assign(__assign({}, rawTheme.typography.subtitle1), { fontSize: 18 }), body1: __assign(__assign({}, rawTheme.typography.body2), { fontWeight: rawTheme.typography.fontWeightRegular, fontSize: 16 }), body2: __assign(__assign({}, rawTheme.typography.body1), { fontSize: 14 }) }), overrides: {
        MuiPaper: __assign(__assign({}, (_a = rawTheme.overrides) === null || _a === void 0 ? void 0 : _a.MuiPaper), { root: __assign(__assign({}, (_c = (_b = rawTheme.overrides) === null || _b === void 0 ? void 0 : _b.MuiPaper) === null || _c === void 0 ? void 0 : _c.root), { backgroundColor: 'rgba(255,255,255, 0.8)' }) })
    } });
export default theme;
//# sourceMappingURL=theme.js.map